<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <tradetype-form></tradetype-form>
      </div>
    </div>
  </div>
</template>

<script>
import TradetypeForm from "@/views/tradetype/components/Form.vue";

export default {
  name: "add-tradetype",
  components: {
    TradetypeForm,
  }
};
</script>